import React, { useState, useEffect, useRef } from "react";
import { Calendar, Search, ChevronDown, ChevronUp } from "lucide-react";
import DatePicker from "react-datepicker";
import DiscountInfoModal from "./DiscountInfoModal";

import {
  handleError,
  handleSuccess,
  handleSuccessSession,
  handleSuccessShow,
} from "../../CommonJquery/CommonJquery";
import {
  server_post_data,
  get_booking_data_by_driver,
  save_discount_amount_payment,
} from "../../ServiceConnection/serviceconnection";
import DummyDriver from "../../assets/dummyDriver.jpeg";
import Loader from "../Loader";

const AddDiscount = ({
  activeSection,
  discountInfoModalOpen,
  setDiscountInfoModalOpen,
  driverData,
  imageLink,
  master_data_getDriverData,
  master_data_get,
  selectedDriverId,
  selectedDriverBookingId,
  startDateAll,
  endDateAll,
  dateRangeType,
}) => {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discountNotes, setDiscountNotes] = useState("");
  const [driverDatasingle, setDriverDataSingle] = useState();
  const [finalAmount, setFinalAmount] = useState(0);
  const [bookingData, setBookingData] = useState([]);
  const [discountAmountError, setDiscountAmountError] = useState("");
  const [startDateError, setStartDateError] = useState("");
  const [bookingDataError, setBookingDataError] = useState("");
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [isDriverDropdownOpen, setIsDriverDropdownOpen] = useState(false);
  const [driverSearchQuery, setDriverSearchQuery] = useState("");
  const [rent, setrent] = useState("");
  const [tolls, settolls] = useState("");
  const [damage, setdamage] = useState("");
  const [ticket, setticket] = useState("");
  const [letfees, setletfees] = useState("");
  const [letotherchr, setotherchr] = useState(0);
  // const [deposit, setdeposit] = useState('')
  const [discount, setdiscount] = useState("");
  const [totalamount, settotalamount] = useState("");
  const driverDropdownRef = useRef(null);

  useEffect(() => {
    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (
        driverDropdownRef.current &&
        !driverDropdownRef.current.contains(event.target)
      ) {
        setIsDriverDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleDateChange = async (data) => {
    if (data === null) return;
    setDriverDataSingle(data);
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("booking_id", data.primary_id);
    await server_post_data(get_booking_data_by_driver, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setBookingData(Response.data.message.booking_data);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };
  function formatDateForDisplay(dateObj) {
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObj.getDate().toString().padStart(2, "0");
    const year = dateObj.getFullYear();
    return `${month}/${day}/${year}`;
  }
  useEffect(() => {
    let final =
      Number(rent) +
      Number(tolls) +
      Number(ticket) +
      Number(damage) +
      Number(letfees) +
      Number(letotherchr);
    setFinalAmount(final);
  }, [rent, tolls, damage, ticket, letfees, letotherchr]);

  const handleSave = async () => {
    // if (driverDatasingle?.primary_id != null) {
    //   alert('select Driver')
    // }

    if (selectedDriver == null) {
      alert("select Driver");
      return;
    }

    if (finalAmount <= 0) {
      alert("Total amount must be greater than zero.");
      return;
    }
    // finalAmount

    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("booking_id", bookingData.primary_id);
    fd.append("user_id", driverDatasingle.primary_id);
    fd.append("car_id", bookingData.car_id);
    fd.append("discount", finalAmount);
    fd.append("rent", rent);
    fd.append("damage", damage);
    fd.append("tolls", tolls);
    fd.append("ticket", ticket);
    fd.append("letfees", letfees);
    fd.append("discountNote", discountNotes);
    fd.append("other_charges", letotherchr);
    fd.append("discountDate", formatDate(startDate));
    await server_post_data(save_discount_amount_payment, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setDiscountAmount("");
          setDiscountNotes("");
          // handleSuccessSession(Response.data.message,);
          setDriverDataSingle();
          setFinalAmount(0);
          setDiscountAmountError("");
          setStartDateError("");
          setBookingDataError("");
          setSelectedDriver(null);
          setIsDriverDropdownOpen(false);
          setDriverSearchQuery("");
          setrent("");
          settolls("");
          setdamage("");
          setticket("");
          setletfees("");
          setotherchr(0);
          handleSuccessShow("Successfully Saved!");
          master_data_getDriverData();
          master_data_get(
            startDateAll,
            endDateAll,
            2,
            dateRangeType,
            selectedDriverId,
            selectedDriverBookingId
          );
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };
  function formatDate(dateObj) {
    console.log(dateObj);
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObj.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  const handleSelectDriver = (driver) => {
    setSelectedDriver(driver);
    setDriverDataSingle(driver);
    setIsDriverDropdownOpen(false);
    setDriverSearchQuery("");
    handleDateChange(driver);
  };

  // Filter drivers based on search query
  const filteredDrivers = driverData
    ? driverData.filter(
        (driver) =>
          (driver.name ? driver.name.toLowerCase() : "").includes(
            driverSearchQuery.toLowerCase()
          ) ||
          (driver.primary_id
            ? driver.primary_id.toString().toLowerCase()
            : ""
          ).includes(driverSearchQuery.toLowerCase())
      )
    : [];

  const handleChargeChange = (e, setter) => {
    const value = e?.target?.value;
    if (value === undefined) return;

    if (parseFloat(value) < 0) {
      alert("Rent cannot be negative");
      return;
    }
    setter(value);
  };

  return (
    <>
      {showLoaderAdmin && <Loader />}
      <section
        id="add-discount"
        className={`accounting-section ${
          activeSection === "add-discount" ? "" : "accounting-hidden"
        }`}
      >
        {/* <div className="accounting-section-header">
          <h2 className="accounting-section-title">Add Discount</h2>
          <div className="accounting-header-actions"></div>
        </div> */}

        <div className="accounting-discount-container">
          <div className="accounting-discount-form">
            <div className="accounting-discount-header">
              <div className="accounting-discount-fields">
                <div className="accounting-discount-field">
                  <label htmlFor="discount-date" className="accounting-label">
                    Discount Date
                  </label>
                  <div className="accounting-date-input-wrapper">
                    <input
                      id="start-date"
                      value={formatDateForDisplay(startDate)}
                      className="accounting-date-input borderRadiusnew mt-0"
                      placeholder="MM/DD/YYYY"
                      readOnly
                      disabled
                    />
                    <Calendar className="accounting-date-icon" size={18} />
                  </div>
                </div>

                <div className="accounting-discount-field">
                  <label
                    htmlFor="select-driver-discount"
                    className="accounting-label"
                  >
                    Select Driver
                  </label>
                  <div className="position-relative" ref={driverDropdownRef}>
                    <div
                      className="form-floating form-control shadow-sm d-flex justify-content-between align-items-center cursor-pointer"
                      onClick={() =>
                        setIsDriverDropdownOpen(!isDriverDropdownOpen)
                      }
                      style={{
                        cursor: "pointer",
                        height: "40px",
                        paddingTop: "10px",
                        marginTop: "6px",
                      }}
                    >
                      {selectedDriver ? (
                        <div className="fw-medium">{selectedDriver.name}</div>
                      ) : (
                        <div className="">Choose a driver</div>
                      )}
                      <div
                        className="position-absolute"
                        style={{
                          bottom: "6px",
                          right: "10px",
                          pointerEvents: "none",
                        }}
                      >
                        {isDriverDropdownOpen ? (
                          <ChevronUp size={16} />
                        ) : (
                          <ChevronDown size={16} />
                        )}
                      </div>
                    </div>

                    {isDriverDropdownOpen && (
                      <div
                        className="position-absolute w-100 bg-white shadow-lg rounded-bottom z-index-1000"
                        style={{ zIndex: 1000 }}
                      >
                        <div className="p-2 border-bottom">
                          <div className="input-group">
                            <span
                              className="input-group-text bg-white border-end-0"
                              style={{ marginTop: "5px" }}
                            >
                              <Search size={16} />
                            </span>
                            <input
                              type="text"
                              className="form-control border-start-0"
                              placeholder="Search by name or ID..."
                              value={driverSearchQuery}
                              onChange={(e) =>
                                setDriverSearchQuery(e.target.value)
                              }
                              autoFocus
                            />
                          </div>
                        </div>
                        <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                          {/* {filteredDrivers && filteredDrivers.length > 0 ? (
                            filteredDrivers.map((driver) => (
                              <div
                                key={driver.primary_id}
                                className="p-2 border-bottom hover-bg-light cursor-pointer"
                                onClick={() => handleSelectDriver(driver)}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="fw-medium">{driver.name}</div>
                                <div className="small text-muted">
                                  ID: {driver.primary_id}
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="p-3 text-center text-muted">
                              No drivers found
                            </div>
                          )} */}
                          {filteredDrivers.length > 0 ? (
                            filteredDrivers.map((driver) => (
                              <div
                                key={driver.primary_id}
                                className="p-2 border-bottom hover-bg-light cursor-pointer"
                                // onClick={() => handleSelectDriver(driver)}
                                onClick={() => {
                                  const booking = driver?.booking_data;
                                  console.log("mk", booking);

                                  if (!booking) {
                                    alert("This driver has no booking.");
                                    setSelectedDriver(null);
                                    return;
                                  }

                                  const step = booking.step_for_booking;
                                  const switchType =
                                    booking.payment_cycle_switch;

                                  if (
                                    step === "5" &&
                                    ["1", "2", "3"].includes(switchType)
                                  ) {
                                    alert(
                                      "This driver has no active booking. The last booking was a switched booking."
                                    );
                                    setSelectedDriver(null);
                                    return;
                                  }

                                  if (step === "6") {
                                    alert(
                                      "Please complete the last booking switch process before continuing."
                                    );
                                    setSelectedDriver(null);
                                    return;
                                  }

                                  if (step === "7") {
                                    alert(
                                      "Please complete the last booking repo process before continuing."
                                    );
                                    setSelectedDriver(null);
                                    return;
                                  }

                                  if (["0", "1", "2", "3"].includes(step)) {
                                    alert(
                                      "This driver has a booking in progress but it is not active yet."
                                    );
                                    setSelectedDriver(null);
                                    return;
                                  }

                                  if (["9", "10"].includes(step)) {
                                    alert(
                                      "The last booking was either rejected or canceled."
                                    );
                                    setSelectedDriver(null);
                                    return;
                                  }

                                  handleSelectDriver(driver);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="fw-medium">{driver.name}</div>
                                <div className="small text-muted">
                                  ID: {driver.primary_id}
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="p-3 text-center text-muted">
                              No drivers found
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {driverDatasingle && (
                <div className="accounting-driver-profile">
                  <div className="accounting-driver-avatar-container">
                    <img
                      // src={
                      //   driverDatasingle.user_image &&
                      //   driverDatasingle.user_image.trim() !== "" &&
                      //   driverDatasingle.user_image.trim().toLowerCase() !==
                      //     "null"
                      //     ? imageLink + driverDatasingle.user_image
                      //     : "https://avatar.iran.liara.run/public/36"
                      // }
                      src={DummyDriver}
                      alt="Driver Photo"
                      className="accounting-driver-avatar-large"
                    />
                  </div>
                  <div>
                    <h3 className="accounting-driver-name-large">
                      {driverDatasingle.name}
                    </h3>
                    <p className="accounting-driver-details">
                      ID: DR-{driverDatasingle.primary_id}
                      {/* • Outstanding: $
                    {(bookingData && bookingData.due_rent) || 0} */}
                    </p>
                  </div>
                </div>
              )}

              {/* <div className="accounting-discount-amount-field">
              <label htmlFor="discount-amount" className="accounting-label">
                Discount Amount ($)
              </label>
              <div className="accounting-amount-input-container">
                <span className="accounting-currency-symbol">$</span>
                <input
                  type="text"
                  name="discount-amount"
                  id="discount-amount"
                  className="accounting-amount-input-with-symbol"
                  placeholder="0.00"
                  onChange={(e) => setDiscountAmount(e.target.value)}
                />
                <span className="accounting-currency-code">USD</span>
              </div>
            </div> */}
              <form className="createRightsForm mt-4" id="createRightsForm">
                <div className="accounting-services-due">
                  <div className="accounting-services-header">
                    <h3 className="accounting-services-title">
                      {" "}
                      Discount Amount ($)
                    </h3>
                  </div>

                  <div className="accounting-services-list">
                    <div className="accounting-service-item">
                      <div className="accounting-service-info">
                        <div className="accounting-service-checkbox">
                          <label
                            htmlFor="rent_amount"
                            className="accounting-service-label"
                          >
                            <span className="accounting-service-name">
                              Rent
                            </span>
                          </label>
                        </div>
                      </div>

                      <div className="accounting-service-amount">
                        <span className="accounting-amount-due">
                          ${selectedDriver?.booking_data?.due_rent || 0}
                        </span>

                        <input
                          type="number"
                          id="rent"
                          name="rent"
                          className="accounting-amount-input"
                          placeholder="Amount"
                          value={rent}
                          onChange={(e) => {
                            const newValue = e.target.value;

                            // If input is empty or not a number, just update
                            if (newValue === "" || isNaN(Number(newValue))) {
                              setrent(newValue);
                              return;
                            }

                            const enteredRent = Number(newValue);
                            const totalRent = Number(
                              selectedDriver?.booking_data?.due_rent || 0
                            );
                            if (enteredRent < 0) {
                              alert("Rent cannot be negative");
                              return;
                            }

                            // Only update state if value is valid
                            if (enteredRent >= 0) {
                              setrent(newValue);
                            } else {
                              // For invalid values, show alert but don't update state
                              e.preventDefault(); // Prevent default behavior
                              alert("Rent cannot be less than zero.");
                              // Keep the previous value by not calling setRent
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div className="accounting-service-item">
                      <div className="accounting-service-info">
                        <div className="accounting-service-checkbox">
                          <label
                            htmlFor="tolls_amount"
                            className="accounting-service-label"
                          >
                            <span className="accounting-service-name">
                              Tolls
                            </span>
                          </label>
                        </div>
                      </div>

                      <div className="accounting-service-amount">
                        <span className="accounting-amount-due">
                          ${selectedDriver?.booking_data?.due_tolls || 0}
                        </span>

                        <input
                          type="number"
                          id="tolls"
                          name="tolls"
                          className="accounting-amount-input"
                          placeholder="Amount"
                          value={tolls} // Changed from defaultValue to value for controlled input
                          onChange={(e) => handleChargeChange(e, settolls)}
                          // onChange={(e) => {
                          //   const newValue = e.target.value;

                          //   // If input is empty or not a number, just update
                          //   if (newValue === '' || isNaN(Number(newValue))) {
                          //     settolls(newValue);
                          //     return;
                          //   }

                          //   const enteredTolls = Number(newValue);
                          //   const totalTolls = Number(selectedDriver?.booking_data?.due_tolls || 0); // Adjust to your actual total tolls property

                          //   // Only update state if value is valid
                          //   if (enteredTolls <= totalTolls) {
                          //     settolls(newValue);
                          //   } else {
                          //     // For invalid values, show alert but don't update state
                          //     e.preventDefault(); // Prevent default behavior
                          //     alert(`Entered tolls cannot be more than due amount ($${totalTolls})`);
                          //     // Keep the previous value by not calling setTolls
                          //   }
                          // }}
                        />
                      </div>
                    </div>

                    <div className="accounting-service-item">
                      <div className="accounting-service-info">
                        <div className="accounting-service-checkbox">
                          <label
                            htmlFor="damage"
                            className="accounting-service-label"
                          >
                            <span className="accounting-service-name">
                              Damage
                            </span>
                          </label>
                        </div>
                      </div>

                      <div className="accounting-service-amount">
                        <span className="accounting-amount-due">
                          ${selectedDriver?.booking_data?.due_damage || 0}
                        </span>
                        <input
                          type="number"
                          id="damage"
                          name="damage"
                          className="accounting-amount-input"
                          placeholder="Amount"
                          value={damage} // Changed from defaultValue to value for controlled input
                          onChange={(e) => handleChargeChange(e, setdamage)}
                          // onChange={(e) => {
                          //   const newValue = e.target.value;

                          //   // If input is empty or not a number, just update
                          //   if (newValue === '' || isNaN(Number(newValue))) {
                          //     setdamage(newValue);
                          //     return;
                          //   }

                          //   const enteredDamage = Number(newValue);
                          //   const totalDamage = Number(selectedDriver?.booking_data?.due_damage || 0);

                          //   // Only update state if value is valid
                          //   if (enteredDamage <= totalDamage) {
                          //     setdamage(newValue);
                          //   } else {
                          //     // For invalid values, show alert but don't update state
                          //     e.preventDefault(); // Prevent default behavior
                          //     alert(`Entered damage fee cannot be more than due amount ($${totalDamage})`);
                          //     // Keep the previous value by not calling setDamage
                          //   }
                          // }}
                        />
                      </div>
                    </div>

                    <div className="accounting-service-item">
                      <div className="accounting-service-info">
                        <div className="accounting-service-checkbox">
                          <label
                            htmlFor="tickets"
                            className="accounting-service-label"
                          >
                            <span className="accounting-service-name">
                              Tickets
                            </span>
                          </label>
                        </div>
                      </div>

                      <div className="accounting-service-amount">
                        <span className="accounting-amount-due">
                          ${selectedDriver?.booking_data?.due_ticket || 0}
                        </span>
                        {/* <span className="accounting-amount-due">${selectedDriver?.booking_data?.due_ticket || 0}</span> */}
                        <input
                          type="number"
                          id="tickets"
                          name="tickets"
                          className="accounting-amount-input"
                          placeholder="Amount"
                          value={ticket} // Changed from defaultValue to value for controlled input
                          onChange={(e) => handleChargeChange(e, setticket)}
                          // onChange={(e) => {
                          //   const newValue = e.target.value;

                          //   // If input is empty or not a number, just update
                          //   if (newValue === '' || isNaN(Number(newValue))) {
                          //     setticket(newValue);
                          //     return;
                          //   }

                          //   const enteredTicket = Number(newValue);
                          //   const totalTickets = Number(selectedDriver?.booking_data?.due_ticket || 0);

                          //   // Only update state if value is valid
                          //   if (enteredTicket <= totalTickets) {
                          //     setticket(newValue);
                          //   } else {
                          //     // For invalid values, show alert but don't update state
                          //     e.preventDefault(); // Prevent default behavior
                          //     alert(`Entered ticket amount cannot be more than due amount ($${totalTickets})`);
                          //     // Keep the previous value by not calling setTicket
                          //   }
                          // }}
                        />
                      </div>
                    </div>

                    <div className="accounting-service-item" hidden>
                      <div className="accounting-service-info">
                        <div className="accounting-service-checkbox">
                          <label
                            htmlFor="latefees"
                            className="accounting-service-label"
                          >
                            <span className="accounting-service-name">
                              Late Fees
                            </span>
                          </label>
                        </div>
                      </div>
                      <div className="accounting-service-amount">
                        <span className="accounting-amount-due">
                          ${selectedDriver?.booking_data?.due_latefees || 0}
                        </span>
                        <input
                          type="number"
                          id="latefees"
                          name="latefees"
                          className="accounting-amount-input"
                          placeholder="Amount"
                          value={letfees}
                          onChange={(e) => handleChargeChange(e, setletfees)}
                          // onChange={(e) => {
                          //   const newValue = e.target.value;

                          //   // If input is empty or not a number, just update
                          //   if (newValue === '' || isNaN(Number(newValue))) {
                          //     setletfees(newValue);
                          //     return;
                          //   }

                          //   const enteredLateFees = Number(newValue);
                          //   const totalLateFees = Number(selectedDriver?.booking_data?.due_latefees || 0);

                          //   // Only update state if value is valid
                          //   if (enteredLateFees <= totalLateFees) {
                          //     setletfees(newValue);
                          //   } else {
                          //     // For invalid values, show alert but don't update state
                          //     e.preventDefault(); // Prevent default behavior
                          //     alert(`Entered late fees cannot be more than due amount ($${totalLateFees})`);
                          //     // Keep the previous value by not calling setLetfees
                          //   }
                          // }}
                        />
                      </div>
                    </div>
                    <div className="accounting-service-item">
                      <div className="accounting-service-info">
                        <div className="accounting-service-checkbox">
                          <label
                            htmlFor="latefees"
                            className="accounting-service-label"
                          >
                            <span className="accounting-service-name">
                              Other Charges
                            </span>
                          </label>
                        </div>
                      </div>
                      <div className="accounting-service-amount">
                        <span className="accounting-amount-due">
                          $
                          {selectedDriver?.booking_data?.due_other_charges || 0}
                        </span>
                        <input
                          type="number"
                          id="otherCharge"
                          name="otherCharge"
                          className="accounting-amount-input"
                          placeholder="Amount"
                          value={letotherchr}
                          onChange={(e) => handleChargeChange(e, setotherchr)}
                          // onChange={(e) => {
                          //   const newValue = e.target.value;

                          //   // If input is empty or not a number, just update
                          //   if (newValue === '' || isNaN(Number(newValue))) {
                          //     setotherchr(newValue);
                          //     return;
                          //   }

                          //   const enteredother_charges = Number(newValue);
                          //   const totalother_charges = Number(selectedDriver?.booking_data?.due_other_charges || 0);

                          //   // Only update state if value is valid
                          //   if (enteredother_charges < 0) {
                          //     e.preventDefault();
                          //     alert("other charges amount cannot be negative.");
                          //   }
                          //     else if (enteredother_charges <= totalother_charges) {
                          //       setotherchr(newValue);
                          //   } else {
                          //     // For invalid values, show alert but don't update state
                          //     e.preventDefault(); // Prevent default behavior
                          //     alert(`Entered Other Charges cannot be more than due amount ($${totalother_charges})`);
                          //     // Keep the previous value by not calling setotherchr
                          //   }
                          // }}
                        />
                      </div>
                    </div>

                    <div className="accounting-service-total">
                      <div>
                        <span className="accounting-total-label">
                          Total Amount
                        </span>
                      </div>
                      <div>
                        <span className="accounting-total-amount">
                          ${finalAmount}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <div className="accounting-discount-reason-field">
                <label htmlFor="discount-reason" className="accounting-label">
                  Reason for Discount (Optional)
                </label>
                <textarea
                  id="discount-reason"
                  rows="3"
                  className="accounting-textarea"
                  placeholder="Add reason for providing this discount..."
                  onChange={(e) => setDiscountNotes(e.target.value)}
                ></textarea>
              </div>

              <div className="accounting-discount-warning">
                <div className="accounting-warning-icon">
                  <i className="bi bi-exclamation-triangle"></i>
                </div>
                <div className="accounting-warning-text">
                  Discount will reduce the outstanding dues of the driver
                  immediately. This action cannot be undone.
                </div>
              </div>

              <div className="accounting-discount-actions">
                <button
                  type="button"
                  className="accounting-btn accounting-btn-secondary"
                >
                  Cancel
                </button>
                <button
                  id="save-discount-btn"
                  type="button"
                  className="accounting-btn accounting-btn-primary"
                  onClick={handleSave}
                >
                  Save Discount
                </button>
              </div>
            </div>
          </div>

          {/* <div className="accounting-discount-sidebar">
          <div className="accounting-discount-summary">
            <h3 className="accounting-summary-title">Discount Summary</h3>
            <div className="accounting-summary-details">
              <div className="accounting-summary-row">
                <span className="accounting-summary-label">
                  Driver Outstanding:
                </span>
                <span className="accounting-summary-value accounting-value-debit">
                  ${(bookingData && bookingData.total_due) || 0}
                </span>
              </div>
              <div className="accounting-summary-row">
                <span className="accounting-summary-label">
                  Discount Amount:
                </span>
                <span className="accounting-summary-value accounting-value-credit">
                  ${discountAmount}
                </span>
              </div>
              <div className="accounting-summary-divider"></div>
              <div className="accounting-summary-row">
                <span className="accounting-summary-label accounting-label-bold">
                  New Outstanding:
                </span>
                <span className="accounting-summary-value accounting-value-debit accounting-value-bold">
                  ${finalAmount}
                </span>
              </div>
            </div>
          </div>
        </div> */}
        </div>
      </section>
    </>
  );
};

export default AddDiscount;
